import { CustomReportRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function AnalysisCustomReportRoute() {
  const { workspaceId, reportId } = Route.useParams();
  return <CustomReportRoute segment="analysis" workspaceId={workspaceId} reportId={reportId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/analysis/custom-reports/$reportId')({
  component: AnalysisCustomReportRoute,
});
